<template>
    <div class="loading-mask" v-if="status">
        <div class="loading">
            <van-loading color="#1989fa" vertical></van-loading>
            <div>加载中...</div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'dc-loading',
  data () {
    return {
      status: false
    }
  },
  methods: {
    trigger (type) {
      this.status = type
    }
  }
}
</script>

<style scoped lang="scss">
.loading-mask {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    //background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loading {
    width: 280px;
    height: 242px;
    background: rgba(0, 0, 0, 0.90);
    box-shadow: 0 40px 80px 0 rgba(0, 0, 0, 0.10);
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #ffffff
}

img {
    margin-bottom: 30px;
    width: 60px;
    height: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/common/dc-loading/dc-loading.vue